import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"videos,video-playlist"} maskId="square-filled-radius-0-stroke-1-IconVideos"><path fillRule="evenodd" clipRule="evenodd" d="M4 3H20V4H4V3ZM2 5H22V21H2V5ZM10 9.52841L14.8602 13L10 16.4716V9.52841Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVideos;
